<template>
    <v-container>
        <v-row v-if="company!=null">
            <v-col cols="6" xs="12">
                <v-card-text>
                    <span class="headline font-weight-light">Ihre Geräte</span>
                </v-card-text>
            </v-col>
            <v-col cols="6" xs="12" style="text-align: right">
                <v-btn @click="close" icon color="black"><v-icon>close</v-icon></v-btn>
            </v-col>
        </v-row>
        <v-row v-if="devices != null">
            <v-col>
                <WidgetMeineGeraete :devices="devices"></WidgetMeineGeraete>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import WidgetMeineGeraete from "../../WidgetMeineGeraete";
    import Vue from "vue";

    export default {
        name: "MyDevices",
        components: {WidgetMeineGeraete},
        data: () => ({
            numberOfItemsCard: '15 Items',
            titleGeraete: 'Mein Gerät ...',
            playlistName: 'Name der Playlist',
            model1: null,
            dialog: false,
            value: '',
            forename: '',
            company: null,
            lastname: '',
            drawer: null,
            userData: '',
            isShowMenu: false,
            model: '',
            ApplicationName: 'Kermax',
            showSearch: false,
            showNotify: false,
            showApps: false,
            companyId: null,
            items: [
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Navigation',
                    id: '1',
                    model: 'true',
                    children: []
                }
                /* ,
                {
                  icon: 'keyboard_arrow_up',
                  'icon-alt': 'keyboard_arrow_down',
                  text: 'Admin',
                  id: '2',
                  model: 'true',
                  children: [
                    {icon: 'supervisor_account', text: 'Benutzer', url: '/Dashboard/Benutzer'}
                  ],
                } */

            ],
            companyData: null,
            devices: null,
            modules: [
                {
                    color: '#fcbf00',
                    cnt: '0',
                    visible: false,
                    title: 'Netzwerke',
                    icon: 'business'
                },
                {
                    color: '#fcbf00',
                    cnt: '0',
                    visible: false,
                    title: 'Mein Standort',
                    icon: 'house'
                },
                {
                    color: '#1B5E20',
                    cnt: '0',
                    visible: false,
                    title: 'Playlist',
                    icon: 'play_circle_outline'
                },
                {
                    color: '#E65100',
                    cnt: '0',
                    visible: false,
                    title: 'Meine Geräte',
                    icon: 'devices'
                },
                {
                    color: '#26C6DA',
                    cnt: '0',
                    visible: false,
                    title: 'Benutzer',
                    icon: 'people'
                }
            ]
        }),
        computed: {
            myItems() {
                var cmp = this
                return cmp.modules.filter(item => {
                    return item.visible
                })
            }
        },
        methods: {
            close: function () {
                this.$router.push('/Dashboard/Main')
            },
            onGetDevices: function (data) {
                this.devices = data
                this.modules[2].cnt = data.length
            },
            onGetData: function (data) {
                this.companyData = data
                this.company = data[0]
                Vue.prototype.$api.loadDevicesFromCompany(this.companyId, this.onGetDevices)
            },
            reload: function () {
                var reqData = {
                    isMother: 1
                }
                reqData.guid = Vue.prototype.$api.getCredentials().data.guidParent

                Vue.prototype.$apiCompany.loadCompanies(reqData, this.onGetData)
            }
        },
        mounted() {
            this.userData = Vue.prototype.$api.getCredentials().data
            this.companyId = Vue.prototype.$api.getCredentials().data.guidParent
            this.reload()
        }
    }
</script>

<style scoped>

</style>
